import { EMAIL, EMAIL_TOO_LONG, FIELD_IS_REQUIRED } from 'src/common/validation/errors';
import { EMAIL_REGEX } from 'src/common/validation/validators';
import * as Yup from 'yup';

export function getEmailValidator() {
  return (
    Yup.string()
      .transform((emailAddress) => (typeof emailAddress === 'string' ? emailAddress.trim() : emailAddress))
      .matches(EMAIL_REGEX, EMAIL)
      // Field length limitaion in database
      .max(200, EMAIL_TOO_LONG)
      .required(FIELD_IS_REQUIRED)
      .default('')
  );
}
